import {getAuthorizationHistory} from "./actions/getHistory";

export const actions = {
    getAuthorizationHistory,
};
